module.exports = __webpack_public_path__ + "img/lk-menu-exit.737fd6fd.svg";